<template>
	<div class="chat-fans-list">
		<div class="chat-fans-search">
			<div class="chat-fans-search-input">
				<input type="text" placeholder="请输入昵称" v-model="keyword">
				<span class="chat-fans-search-icon"></span>
			</div>
			<div class="chat-fans-search-filter" @click="customFilterClick">
			</div>
			<div class="chat-fans-add">
			</div>
			<div class="chat-fans-reload" @click="reload">
			</div>
		</div>
		<div class="chat-fans-options">
			<div class="chat-fans-option" @click="optionClick('new')" :class="{'chat-fans-option-active': currentOption == 'new'}">
				<div class="chat-fans-o-icon chat-fans-o-new"></div>
				<div class="chat-fans-o-text">新的好友（<span>{{newTotal}}</span>）</div>
			</div>
			<div class="chat-fans-option" @click="optionClick('chat')" :class="{'chat-fans-option-active': currentOption == 'chat'}">
				<div class="chat-fans-o-icon chat-fans-o-chat"></div>
				<div class="chat-fans-o-text">已聊天好友（<span>{{chatTotal}}</span>）</div>
			</div>
			<div class="chat-fans-option" @click="optionClick('no-chat')" :class="{'chat-fans-option-active': currentOption == 'no-chat'}">
				<div class="chat-fans-o-icon chat-fans-o-no-chat"></div>
				<div class="chat-fans-o-text">未聊天好友（<span>{{noChatTotal}}</span>）</div>
			</div>
			<div class="chat-fans-option" @click="optionClick('zan')" :class="{'chat-fans-option-active': currentOption == 'zan'}">
				<div class="chat-fans-o-icon chat-fans-o-zan"></div>
				<div class="chat-fans-o-text">朋友圈点赞好友（<span>{{zanTotal}}</span>）</div>
			</div>
			<div class="chat-fans-option" @click="optionClick('comment')" :class="{'chat-fans-option-active': currentOption == 'comment'}">
				<div class="chat-fans-o-icon chat-fans-o-comment"></div>
				<div class="chat-fans-o-text">朋友圈评论好友（<span>{{commentTotal}}</span>）</div>
			</div>
			<div class="chat-fans-option" @click="optionClick('all')" :class="{'chat-fans-option-active': currentOption == 'all'}">
				<div class="chat-fans-o-icon chat-fans-o-all"></div>
				<div class="chat-fans-o-text">全部好友（<span>{{total}}</span>）</div>
			</div>
		</div>
		<div class="chat-fans-items">
			<div class="chat-fans-items-wrap" id="chat-fans-items-wrap" @scroll="fansScroll">
				<div class="chat-fans-item" v-for="fans in fansList" @click="fansClick(fans)" 
				:class="{'chat-fans-item-active': fans.id == currentFans.id}" 
				:key="'chat-fans-list-'+fans.id">
					<div class="chat-fans-avater">
						<img :src="fans.wx_photo" alt="">
					</div>
					<div class="chat-fans-name">
						<span>{{fans.wx_name}}</span>
						<span v-if="fans.con_remark !== '' && fans.con_remark !== null" style="font-size: 12px;color: #666666;">{{fans.con_remark}}</span>
					</div>
				</div>
				<div class="chat-fans-refresh" v-if="!canRefresh">
					<img src="/img/loading.gif" alt="" v-if="!isEnd">
					<span v-if="!isEnd">数据加载中...</span>
					<span v-if="isEnd">{{fansList.length}}条记录</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getFansList,getFansCount} from '../../../network/local/friend.js'
	import {webGetFanspassList,webGetFanspassCount} from '../../../network/web/fanspass.js'
	
	export default {
		name: "ChatFansList",
		props:{
			currentCustom:{
				type: Object,
				default:function(){
					return{
						id: 0
					}
				}
			},
			customList:{
				type: Array,
				default: []
			},
			deleteFanspassId:{
				type: Number,
				default: 0
			}
		},
		data(){
			return {
				keyword: '',
				lastId: 0,
				canRefresh: false,
				isEnd:false,
				filterOpen: false,
				currentOption: 'all',
				currentFans:{},
				fansList: [],
				total: 0,
				chatTotal: 0,
				noChatTotal: 0 ,
				newTotal: 0,
				zanTotal: 0 ,
				commentTotal: 0,
				scrollTop:0
			}
		},
		methods:{
			// 初始数据
			init(){
				this.canRefresh = false
				this.isEnd = false
				this.lastId = 0
				this.fansList = []
				this.scrollTop = 0
			},
			// 客服过滤点击
			customFilterClick(){
				this.filterOpen = !this.filterOpen
				this.$emit('custom-filter',this.filterOpen)
			},
			
			// 菜单分类点击
			optionClick(value){
				if(this.currentOption !== value){
					this.currentOption = value
					this.init()
					this.showData()
				}	
			},
			
			// 粉丝点击
			fansClick(value){
				this.currentFans = value
				this.$emit('fans-click',value)
			},
			
			// 滚动刷新数据
			fansScroll(event){
				let page = document.getElementById("chat-fans-items-wrap")
				this.scrollTop = page.scrollTop
				if(page.scrollTop+page.clientHeight >= page.scrollHeight-25 && this.canRefresh){
					this.canRefresh = false
					this.showData()
				}
			},
			
			// 获取数据，并渲染列表
			showData(){
			  let param = {
				  optType: this.currentOption,
				  keyword: this.keyword
			  }
			  // 查本地库
			  if(this.currentOption !== 'new'){
				  getFansList(this.currentCustom.id,this.lastId,param,(data)=>{
					let len = data.length
					if(len > 0){
						for(let i = 0;i<len;i++){
							let fans = data[i]
							fans.pageType = 'fans'
							this.fansList.push(fans)
						}
						this.lastId = data[len - 1].id
						this.canRefresh = true
					}else{
						this.canRefresh = false
						this.isEnd = true
					}
				  })
			  }
			  // 查服务器列表的进粉列表
			  else{
				  let wxids = ''
				  if(this.currentCustom.id !== 0){
				  	wxids = this.currentCustom.open_id
				  }else{
				  	let customOpenIds = []
				  	for (let i = 0; i < this.customList.length; i++) {
				  		customOpenIds.push(this.customList[i].open_id)
				  	}
				  	wxids = customOpenIds.join(',')
				  }
				  webGetFanspassList(wxids,this.lastId,data=>{
					  let len = data.length
					  if(len > 0){
					  	for(let i = 0;i<len;i++){
							let fans = data[i]
							fans.pageType = 'news'
							fans.wx_name = fans.from_name
							fans.wx_photo = fans.from_photo
					  		this.fansList.push(fans)
					  	}
					  	this.lastId = data[len - 1].id
					  	this.canRefresh = true
					  }else{
					  	this.canRefresh = false
					  	this.isEnd = true
					  }
				  })
				  
			  }
			},
			
			// 获取各大类的粉丝总数
			getCotegroyCount(){
				// 获取本地的数量
				getFansCount(this.currentCustom.id,data=>{
					this.total = data.total
					this.chatTotal = data.chatTotal
					this.noChatTotal = data.noChatTotal
					this.zanTotal = data.zanChatTotal
					this.commentTotal = data.commentChatTotal
				})
				if(this.customList.length === 0){
					return
				}
				this.getFanspassCount()
			},
			
			// 获取新进粉数据
			getFanspassCount(){
				let wxids = ''
				if(this.currentCustom.id !== 0){
					wxids = this.currentCustom.open_id
				}else{
					let customOpenIds = []
					for (let i = 0; i < this.customList.length; i++) {
						customOpenIds.push(this.customList[i].open_id)
					}
					wxids = customOpenIds.join(',')
				}
				webGetFanspassCount(wxids,data=>{
					this.newTotal = data
				})
			},
			
			// 重新加载
			reload(){
				this.init()
				this.showData()
				this.getCotegroyCount()
			},
			
			// 根据id，删除进粉列表数据
			deleteFanspass(data){
				let index = -1
				if(data.type === 1 && data.id > 0){
					for (let i = 0; i < this.fansList.length; i++) {
						if(this.fansList[i].id == data.id){
							index = i
							break
						}
					}
				}else if(data.type === 2 && data.a_wxid !== undefined &&  data.f_wxid !== undefined){
					for (let i = 0; i < this.fansList.length; i++) {
						if(this.fansList[i].wxid == data.a_wxid && this.fansList[i].from_vxid == data.f_wxid){
							index = i
							break
						}
					}
				}
				if(index === -1){
					return
				}
				this.newTotal--
				this.fansList.splice(index,1)
				if(this.fansList.length === 0){
					this.fansClick({})
					this.showData()
				}else{
					let fans = this.fansList[0]
					if(this.fansList[index] !== undefined){
						fans = this.fansList[index]
					}
					this.fansClick(fans)
				}
			}
		},
		
		computed:{
			  // 新消息
			  newMsg(){
				return this.$store.state.currentRecentlyMsg
			  }
		},
		
		watch:{
			// 监听客服点击，重新渲染粉丝列表
			currentCustom(nVal){
				this.init()
				this.showData()
				this.getCotegroyCount()
			},
			
			// 监听客服列表变化-只用一次
			customList(nVal){
				this.getFanspassCount()
			},
			
			// 监听进粉数据删除
			deleteFanspassId(nVal){
				this.deleteFanspass({
					type: 1,
					id: nVal
				})
			},
			
			// 监听新消息
			newMsg(nVal){
				if(nVal.chat_type === 1){
					this.deleteFanspass({
						type: 2,
						a_wxid: nVal.account_open_id,
						f_wxid: nVal.friends_open_id
					})
				}
			},
			
			// 监听搜索框变化
			keyword(){
				this.init()
				this.showData()
			}
		},
		
		// 只有组件被缓存时，才会调用这2个方法
		activated() {
			let page = document.getElementById("chat-fans-items-wrap")
			page.scrollTop = this.scrollTop
		},
		
		mounted() {
			this.getCotegroyCount()
			this.showData()
		}
	}
</script>

<style>
	.chat-fans-list{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		user-select: none;
	}
	.chat-fans-list .chat-fans-search{
		width: 100%;
		padding: 0 20px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}
	.chat-fans-search .chat-fans-search-input{
		width: 0;
		height: 30px;
		position: relative;
		flex-grow: 1;
		margin-right: 8px;
	}
	.chat-fans-search .chat-fans-search-input input{
		display: block;
		height: 30px;
		line-height: 30px;
		width: 100%;
		border: 1px solid #CFCFCF;
		border-radius: 4px;
		padding: 0 10px 0 30px;
		box-sizing: border-box;
		font-size: 12px;
	}
	.chat-fans-search .chat-fans-search-input input:focus{
		outline: none;
		border: 1px solid #42B983;
	}
	.chat-fans-search-input .chat-fans-search-icon{
		width: 30px;
		height: 32px;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(../../../assets/img/c-all-search.png);
		background-size: 18px auto;
		background-repeat: no-repeat;
		background-position: center;	
	}
	.chat-fans-search .chat-fans-search-filter,.chat-fans-search .chat-fans-add,.chat-fans-search .chat-fans-reload{
		width: 24px;
		height: 24px;
		background-size: 12px auto;
		background-repeat: no-repeat;
		background-position: center;	
		border: 1px solid #b1b1b1;
		border-radius: 15px;
		cursor: pointer;
	}
	.chat-fans-search .chat-fans-search-filter{
		background-image: url(../../../assets/img/c-all-filter.png);
	}
	.chat-fans-search .chat-fans-add{
		background-image: url(../../../assets/img/c-all-add.png);
		margin-left: 8px;
	}
	.chat-fans-search .chat-fans-reload{
		background-image: url(../../../assets/img/comp-m-reload.png);
		margin-left: 8px;
		background-size: 14px auto;
	}
	.chat-fans-list .chat-fans-options{
		width: 100%;
		height: auto;
	}
	.chat-fans-options .chat-fans-option{
		width: 100%;
		padding: 5px 20px;
		height: 40px;
		overflow: hidden;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.chat-fans-options .chat-fans-option-active{
		background-color: #dedede;
	}
	.chat-fans-option .chat-fans-o-icon{
		width: 20px;
		height: 20px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	.chat-fans-option .chat-fans-o-new{
		background-image: url(../../../assets/img/fans-new.png);
	}
	.chat-fans-option .chat-fans-o-chat{
		background-image: url(../../../assets/img/fans-chat.png);
	}
	.chat-fans-option .chat-fans-o-no-chat{
		background-image: url(../../../assets/img/fans-no-chat.png);
	}
	.chat-fans-option .chat-fans-o-zan{
		background-image: url(../../../assets/img/fans-zan.png);
	}
	.chat-fans-option .chat-fans-o-comment{
		background-image: url(../../../assets/img/fans-comment.png);
	}
	.chat-fans-option .chat-fans-o-all{
		background-image: url(../../../assets/img/fans-all.png);
		background-size: 18px 18px !important;
	}
	.chat-fans-option .chat-fans-o-text{
		margin: 0 10px;
	}
	.chat-fans-o-text span{
		color: #009688;
		font-weight: 600;
	}
	.chat-fans-list .chat-fans-items{
		position: absolute;
		top: 290px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
	.chat-fans-items .chat-fans-items-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-fans-items-wrap::-webkit-scrollbar{
		width: 6px;
		height: auto;
	}
	.chat-fans-items-wrap::-webkit-scrollbar-track{
	  border-radius: 3px;
	  background:#e3e3e3;
	}
	.chat-fans-items-wrap::-webkit-scrollbar-thumb{
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background:#cbcbcb;
		cursor: pointer;
	}
	.chat-fans-items-wrap .chat-fans-item{
		height: 50px;
		padding: 5px 20px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.chat-fans-items-wrap .chat-fans-item-active{
		background-color: #dedede;
	}
	.chat-fans-item .chat-fans-avater{
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 10px;
	}
	.chat-fans-avater img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-fans-item .chat-fans-name{
		height: 40px;
		width: 0;
		flex-grow: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}
	.chat-fans-refresh{
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #42B983;
	}
	.chat-fans-refresh > *{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-fans-refresh img{
		margin-right: 5px;
	}
</style>
